import SectionTitle from '@components/pages/home/epnbz/Base/SectionTitle';
import useI18n from '@i18n';

import styles from './Traffics.module.scss';

import arbitageImg from './img/arbitrage.svg';
import blogersImg from './img/blogers.svg';
import cashBackServiceImg from './img/cashback-service.svg';
import loyalityImg from './img/loyality.svg';
import mediaImg from './img/media.svg';
import partnersImg from './img/partners.svg';
import promocodesImg from './img/promocodes.svg';
import serviceImg from './img/services.svg';
import socialsImg from './img/socials.svg';

const BlockTraffics: React.FC = () => {
    const { t } = useI18n('Cpa');
    return (
        <section className={styles.landingContainer}>
            <div className={styles.traffics}>
                <SectionTitle classname={styles.title}>
                    {t('Increase sales growth through partners with different types of traffic')}
                </SectionTitle>
                <div className={styles.list}>
                    <div className={styles.card}>
                        <div className={styles.img}>
                            <img src={cashBackServiceImg} alt={t('Cashback services')} />
                        </div>
                        <div className={styles.name}>{t('Cashback services')}</div>
                    </div>
                    <div className={styles.card}>
                        <div className={styles.img}>
                            <img src={blogersImg} alt={t('Video bloggers')} />
                        </div>
                        <div className={styles.name}>{t('Video bloggers')}</div>
                    </div>
                    <div className={styles.card}>
                        <div className={styles.img}>
                            <img src={partnersImg} alt={t('Affiliate networks')} />
                        </div>
                        <div className={styles.name}>{t('Affiliate networks')}</div>
                    </div>
                    <div className={styles.card}>
                        <div className={styles.img}>
                            <img src={arbitageImg} alt={t('Traffic arbitrageurs')} />
                        </div>
                        <div className={styles.name}>{t('Traffic arbitrageurs')}</div>
                    </div>
                    <div className={styles.card}>
                        <div className={styles.img}>
                            <img src={promocodesImg} alt={t('Discount and promo code services')} />
                        </div>
                        <div className={styles.name}>{t('Discount and promo code services')}</div>
                    </div>
                    <div className={styles.card}>
                        <div className={styles.img}>
                            <img src={socialsImg} alt={t('Social networks and Influencers')} />
                        </div>
                        <div className={styles.name}>{t('Social networks and Influencers')}</div>
                    </div>
                    <div className={styles.card}>
                        <div className={styles.img}>
                            <img src={mediaImg} alt={t('Content sites and media')} />
                        </div>
                        <div className={styles.name}>{t('Content sites and media')}</div>
                    </div>
                    <div className={styles.card}>
                        <div className={styles.img}>
                            <img src={loyalityImg} alt={t('Loyalty Programs')} />
                        </div>
                        <div className={styles.name}>{t('Loyalty Programs')}</div>
                    </div>
                    <div className={styles.card}>
                        <div className={styles.img}>
                            <img src={serviceImg} alt={t('Price comparison services')} />
                        </div>
                        <div className={styles.name}>{t('Price comparison services')}</div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BlockTraffics;
